export type DashboardCardWidth = 1 | 2 | 3 | 'full';

export const DASHBOARD_CARD_WIDTHS: readonly DashboardCardWidth[] = [1, 2, 3, 'full'];

const WIDE_DASHBOARD_CARD_IDS = new Set([
  'recentActivity',
  'latestFiles',
  'timeOffToday',
  'attention',
  'pharmacyOpenIssues',
  'tipsAndTricks'
]);

export function isDashboardCardWidth(value: unknown): value is DashboardCardWidth {
  return value === 1 || value === 2 || value === 3 || value === 'full';
}

/** Default width for a card before the user customizes it. */
export function getDefaultCardWidth(cardId: string): DashboardCardWidth {
  return WIDE_DASHBOARD_CARD_IDS.has(cardId) ? 2 : 1;
}

/** Clamp a width to an allow-list (e.g. size-1-only cards). */
export function clampCardWidth(
  width: DashboardCardWidth,
  allowed?: readonly DashboardCardWidth[] | null
): DashboardCardWidth {
  if (!allowed || allowed.length === 0) return width;
  if (allowed.includes(width)) return width;
  return allowed[0];
}

export function resolveCardWidth(
  cardId: string,
  width: DashboardCardWidth | undefined,
  getAllowedWidths?: (id: string) => readonly DashboardCardWidth[] | undefined
): DashboardCardWidth {
  const allowed = getAllowedWidths?.(cardId);
  const preferred = width ?? getDefaultCardWidth(cardId);
  return clampCardWidth(preferred, allowed);
}

function widthClassName(width: DashboardCardWidth): string {
  return width === 'full' ? 'dashboard-grid__item--wfull' : `dashboard-grid__item--w${width}`;
}

export function dashboardGridItemClassName(cardId: string, width?: DashboardCardWidth): string {
  const effective = width ?? getDefaultCardWidth(cardId);
  return `dashboard-grid__item ${widthClassName(effective)}`;
}
